import * as moment from 'moment/moment';
export class Event {
  constructor() {
    this.title = '';
    this.all_day = true;
    this.start = moment(new Date()).format('YYYY-MM-DD');
    this.end = moment(new Date()).format('YYYY-MM-DD');
    this.repeat = 'Never';
    this.repeat_end = moment(new Date()).format('YYYY-MM-DD');
    this.visibility = 'Public';
    this.event_type_id = '';

    this.description = '';
    // return this;
  }
  toViewModel(event) {
    this.id = event.id;
    this.title = event.title;
    this.start = event.start;
    this.end = event.end;
    this.all_day = event.all_day;
    this.repeat = event.repeat;
    this.repeat_end = event.repeat_end;
    this.visibility = event.visibility;
    this.event_type_id = event.event_type_id;
    this.description = event.description;

    return this;
  }

  toEditView(item) {
    return {
      id: item.id,
      title: item.title,
      description: item.description,

      start:
        item.all_day == 'Yes'
          ? item.start
            ? moment(item.start).format('YYYY-MM-DD')
            : '----'
          : item.start
            ? new Date(item.start)
            : '----',
      end:
        item.all_day == 'Yes'
          ? item.end
            ? moment(item.end).format('YYYY-MM-DD')
            : '----'
          : item.end
            ? new Date(item.end)
            : '----',

      all_day: item.all_day == 'Yes' ? true : false,
      repeat: item.repeat,
      repeat_end: moment(item.repeat_end).format('YYYY-MM-DD'),
      visibility: item.visibility,
      event_type_id: item.eventType.id,
    };
  }
  toListView(event) {
    return event.map(function (item) {
      let Eventname = item.start ? moment(item.start).format('h:mm:ss a') : '';
      let EventEndTime = item.end ? moment(item.end).format('h:mm:ss a') : '';
      return {
        id: item.id,
        name: item.title + ' ( ' + Eventname + ' - ' + EventEndTime + ')',
        details: item.description,
        start: item.start ? moment(item.start).format('YYYY-MM-DD') : '',
        end: item.end ? moment(item.end).format('YYYY-MM-DD') : '',
        color: item.eventType.color,
        icon: item.eventType.icon,
      };
    });
  }

  toRequestModel(event) {
    let tempEvent = {};
    tempEvent.title = event.title;

    tempEvent.all_day = event.all_day == true ? 'Yes' : 'No';
    tempEvent.repeat = event.repeat;
    if (event.all_day == true) {
      tempEvent.start = moment(event.start).format('YYYY-MM-DD');
      tempEvent.end = moment(event.end).format('YYYY-MM-DD');
    } else {
      tempEvent.start = moment(event.start).format('YYYY-MM-DD HH:mm:ss');
      tempEvent.end = moment(event.end).format('YYYY-MM-DD HH:mm:ss');
    }
    if (event.repeat == 'Never') {
      tempEvent.repeat_end = moment(new Date()).format('YYYY-MM-DD');
    } else {
      tempEvent.repeat_end = event.repeat_end
        ? moment(event.repeat_end).format('YYYY-MM-DD')
        : null;
    }
    tempEvent.visibility = event.visibility;
    tempEvent.event_type_id = event.event_type_id;
    tempEvent.description = event.description;

    return tempEvent;
  }
  toUpdate(event) {
    let tempEvent = {};
    tempEvent.title = event.title;

    tempEvent.all_day = event.all_day == true ? 'Yes' : 'No';
    tempEvent.repeat = event.repeat;
    if (event.all_day == true) {
      tempEvent.start = moment(event.start).format('YYYY-MM-DD');
      tempEvent.end = moment(event.end).format('YYYY-MM-DD');
    } else {
      tempEvent.start = moment(event.start).format('YYYY-MM-DD HH:mm:ss');
      tempEvent.end = moment(event.end).format('YYYY-MM-DD HH:mm:ss');
    }
    if (event.repeat == 'Never') {
      tempEvent.repeat_end = moment(new Date()).format('YYYY-MM-DD');
    } else {
      tempEvent.repeat_end = event.repeat_end
        ? moment(event.repeat_end).format('YYYY-MM-DD')
        : null;
    }
    tempEvent.visibility = event.visibility;
    tempEvent.event_type_id = event.event_type_id ? event.event_type_id : '';
    tempEvent.description = event.description;

    return tempEvent;
  }
}
